import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";
import Modal from './Modal';
import Login from './Login';
import Register from './Register';

export default function Header() {
  const navigate = useNavigate();
  const isAuthenticated = !!localStorage.getItem("userToken");
  const [cartCount, setCartCount] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isRegModalOpen, setIsRegModalOpen] = useState(false);

  useEffect(() => {
    const updateCartCount = () => {
      const userId = localStorage.getItem("currentUserId");
      if (userId) {
        const cartKey = `cart_${userId}`;
        const cartItems = JSON.parse(localStorage.getItem(cartKey) || "[]");
        setCartCount(cartItems.length);
      } else {
        setCartCount(0);
      }
    };

    // Initial count
    updateCartCount();

    // Listen for custom event
    window.addEventListener("cartUpdated", updateCartCount);

    // Also listen for storage changes from other tabs
    window.addEventListener("storage", updateCartCount);

    // Cleanup
    return () => {
      window.removeEventListener("cartUpdated", updateCartCount);
      window.removeEventListener("storage", updateCartCount);
    };
  }, []);

  const handleLogout = (e) => {
    e.preventDefault();
    Swal.fire({
      title: "Are you sure you want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout"
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("userToken");
        Swal.fire({
          title: "Logged Out!",
          text: "You have been successfully logged out.",
          icon: "success",
          confirmButtonColor: "#3085d6"
        }).then(() => {
          navigate("/");
          window.location.reload();
        });
      }
    });
  };

  return (
    <>
      <header className="ltn__header-area ltn__header-3">
        {/* Top Bar */}
        <div className="ltn__header-top-area border-bottom" style={{ background: "#403333" }}>
          <div className="container-fluid px-4 text-white mb-12">
            <div className="row justify-content-between align-items-center">
              {/* Left side */}
              <div className="col-lg-auto col-12 mb-2 mb-lg-0">
                <ul className="d-flex flex-wrap list-unstyled mb-0">
                  <li className="me-4">
                    <Link
                      to="mailto:info@sunrisemeditechsystems.com"
                      className="text-white text-decoration-none"
                    >
                      <i className="icon-mail" /> info@sunrisemeditechsystems.com
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="https://maps.app.goo.gl/G8dLdyZGLUhEcorw5"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white text-decoration-none"
                    >
                      <i className="icon-placeholder" /> Sardar Patel Ringroad, Zundal, Ahmedabad
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Right side */}
              <div className="col-lg-auto col-12">
                <ul className="d-flex gap-3 list-unstyled mb-0">
                  <li><Link to="#"><i className="fab fa-facebook-f" /></Link></li>
                  <li><Link to="#"><i className="fab fa-google" /></Link></li>
                  <li><Link to="#"><i className="fab fa-instagram" /></Link></li>
                  <li><Link to="#"><i className="fab fa-dribbble" /></Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Middle Area */}
        <div className="container-fluid py-3 px-4 text-white">
          <div className="row align-items-center g-3">
            {/* Logo */}
            <div className="col-lg-2 col-md-4 col-12 text-center text-lg-start">
              <Link to="/" onClick={(e) =>{e.preventDefault(); window.location.href="/"}}>
                <img
                  src="img/sunrise_logo.png"
                  alt="Logo"
                  className="img-fluid img-logo"
                />
              </Link>
            </div>

            {/* Search */}
            <div className="col-lg-6 col-md-8 col-12 search-content" >
              <form className="d-flex">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search here..."
                />
                <button type="submit" className="ms-2 " style={{ background: "#f8f9fa" }}>
                  <i className="icon-search btn-search" />
                </button>
              </form>
            </div>

            {/* Account / Cart */}
            <div className="col-lg-3 col-12">
              <ul className="ltn__header-options d-flex justify-content-lg-end justify-content-center gap-3 flex-wrap">
                {!isAuthenticated ? (
                  <>                   
                      <li><button className='sign-in-btn' onClick={() => setIsModalOpen(true)}>Login</button></li>
                    <Modal
                      isOpen={isModalOpen}
                      onClose={() => setIsModalOpen(false)}
                      title="Login"
                    >
                      <Login onClose={() => setIsModalOpen(false)}/>
                    </Modal>
                     <li><button className='register-btn' onClick={() => setIsRegModalOpen(true)}>Register</button></li>
                      <Modal
                      isOpen={isRegModalOpen}
                      onClose={() => setIsRegModalOpen(false)}
                      title="Register"
                    >
                      <Register onClose={() => setIsRegModalOpen(false)}/>
                    </Modal>
                  </>
                ) : (
                  <>
                    <li><Link to="/account" >Account</Link></li>
                    <li><Link to="/wishlist" >Wishlist</Link></li>
                    <li>
                      <Link to="/logout" onClick={handleLogout} >Logout</Link>
                    </li>
                  </>
                )}
                <li>
                  <Link to="/cart" className="position-relative">
                    <i className="icon-shopping-cart" />
                    <sup
                      style={{
                        position: "absolute",
                        top: "-5px",
                        right: "-10px",
                        background: "red",
                        color: "white",
                        borderRadius: "50%",
                        padding: "2px 6px",
                        fontSize: "12px"
                      }}
                    >
                      {cartCount}
                    </sup>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
    </>

  );
}